/**
 * OutputVerdictLine (#2341, #2407) — the Ampel headline for a production-output
 * surface: colour paired with an icon AND a German word, never colour alone.
 * Production-agnostic (no harvest/crop naming) so an animal-yield sibling tile
 * reuses it unchanged; callers compose surface-specific affordances through the
 * generic ``action`` slot (#2407 Gap 2). The ``role="status"`` live region wraps
 * ONLY badge + sentence — interactive content never sits inside a live region.
 */
import type { ReactNode } from 'react';
import { AlertTriangle, CheckCircle2, CircleDashed, TrendingDown } from 'lucide-react';
import type { OutputVerdict, OutputVerdictLevel } from './outputSeries';

const ICONS: Record<OutputVerdictLevel, typeof CheckCircle2> = {
  green: CheckCircle2,
  yellow: AlertTriangle,
  red: TrendingDown,
  neutral: CircleDashed,
};

export default function OutputVerdictLine({ verdict, action }: { verdict: OutputVerdict; action?: ReactNode }) {
  const Icon = ICONS[verdict.level];
  return (
    <div className={`ernteprognose-verdict ernteprognose-verdict--${verdict.level}`}>
      <span className="ernteprognose-verdict__status" role="status">
        <span className="ernteprognose-verdict__badge">
          <Icon size={18} aria-hidden="true" />
          <span className="ernteprognose-verdict__word">{verdict.headline}</span>
        </span>
        <span className="ernteprognose-verdict__sentence">{verdict.sentence}</span>
      </span>
      {action}
    </div>
  );
}
